<p-confirmDialog key="panicalert" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="panicalertconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<div class="selector-item">
		<div>
			<label>School</label>
		</div>

		<div style="margin-left: 10px">
			<caass-schoolselector [ShowAll]="true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText" [Disabled]="IsLoading() == true">
			</caass-schoolselector>
		</div>
	</div>
	<div class="selector-item">
		<div>
			<label>Active</label>
		</div>

		<div style="margin-left: 10px">
			<select
				[disabled]="IsLoading() == true"
				class="form-control"
				name="ActiveOptionID"
				[(ngModel)]="ActiveOptionID"
				(ngModelChange)="onActiveOptionIDChange($event)"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstActiveOption" [ngValue]="o.ID">{{ o.Desc }}</option>
			</select>
		</div>
	</div>
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button [disabled]="IsLoading() == true" class="btn btn-warning" style="margin-left: 5px" (click)="onToggle()">{{ ToggleText }}</button>
		<button *ngIf="IsSU() == true" [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">
			Delete Alert
		</button>
	</div>
</div>

<!--Table-->
<div>
	<p-table
		#mydt
		[value]="lstPanicAlert"
		[loading]="TableLoading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPanicAlert"
		dataKey="PortalPanicAlertID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--PanicAlertMessage-->
				<th>
					<p-columnFilter type="text" field="PanicAlertMessage" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--CreatedBy-->
				<th>
					<p-columnFilter field="CreatedBy" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterCreatedBy
								[ngModel]="value"
								[options]="lstCreatedBy"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolName
								[ngModel]="value"
								[options]="lstSchoolName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--RoomNo-->
				<th>
					<p-columnFilter type="text" field="RoomNo" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--RoomDesc-->
				<th>
					<p-columnFilter type="text" field="RoomDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StartDT-->
				<th>
					<p-columnFilter type="text" field="StartDT" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--EndDT-->
				<th>
					<p-columnFilter type="text" field="EndDT" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="PanicAlertMessage">Message<p-sortIcon field="PanicAlertMessage"></p-sortIcon></th>
				<th pSortableColumn="CreatedBy">Created By<p-sortIcon field="CreatedBy"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="RoomNo">Room Number<p-sortIcon field="RoomNo"></p-sortIcon></th>
				<th pSortableColumn="RoomDesc">Room Description<p-sortIcon field="RoomDesc"></p-sortIcon></th>
				<th pSortableColumn="StartDT">Start Date<p-sortIcon field="StartDT"></p-sortIcon></th>
				<th pSortableColumn="EndDT">End Date<p-sortIcon field="EndDT"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-PanicAlert>
			<tr [pSelectableRow]="PanicAlert" (dblclick)="onRowDblClick(PanicAlert)">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PanicAlert.PanicAlertMessage }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PanicAlert.CreatedBy }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PanicAlert.SchoolName }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PanicAlert.RoomNo }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PanicAlert.RoomDesc }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PanicAlert.StartDTDesc }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="PanicAlert.Active == true ? 'Red' : 'Black'">
					{{ PanicAlert.EndDTDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
